import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["button"];

  vote(e) {
    if (this.buttonTarget.disabled) { return; }

    let totalVotesSpan = this.buttonTarget.querySelector("span.coin-insight-total-votes");

    if (totalVotesSpan === null) { return; }

    let totalVotes = Number(totalVotesSpan.innerHTML);

    if (isNaN(totalVotes)) { return; }

    totalVotesSpan.innerHTML = totalVotes + 1;
    this.buttonTarget.disabled = true;
  }

  voteAndAlert(e) {
    this.vote(e);
    setTimeout(() => alert("Voted successfully"), 3000);
  }
}
